"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consoleSignInUrl = consoleSignInUrl;
exports.default = void 0;
/**
 * Where to send somebody who has been signed out.
 *
 * Console is the account and identity screen, so it is the front door for the
 * whole family of apps. On designer.samsurveyor.com, explorer.samsurveyor.com
 * and channels.samsurveyor.com, Console is the same host with the first label
 * swapped.
 *
 * Anywhere else — localhost, a Cloud Run host, a preview domain — there is no
 * reliable way to guess where Console lives. Guessing wrong would send an
 * author to a dead address. So fall back to this app's own front page and let
 * its own sign-in screen take over.
 *
 * This deliberately does not read sysconfig. It runs at the moment a session
 * ends, which is often the moment the network stopped answering.
 */

const PARENT = 'samsurveyor.com';

/**
 * @param {string} [href]  defaults to the current page's address.
 * @returns {string} an absolute URL, or '/' when there is nothing to work from.
 */
function consoleSignInUrl(href) {
  const location = href || (typeof window !== 'undefined' && window.location ? window.location.href : '');
  if (!location) return '/';
  let url;
  try {
    url = new URL(location);
  } catch (err) {
    return '/';
  }
  if (url.hostname === `console.${PARENT}`) return `${url.origin}/`;
  if (url.hostname.endsWith(`.${PARENT}`)) {
    const labels = url.hostname.split('.');
    labels[0] = 'console';
    return `${url.protocol}//${labels.join('.')}/`;
  }
  return `${url.origin}/`;
}
var _default = exports.default = consoleSignInUrl;